'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { HStack, Spacer } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { AddInboundDataPipelineForm } from './-components/AddInboundDataPipelineForm';
import { InnerNavigation } from './-components/InnerNavigation';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/data-pipeline/add/')({
  component: AddInboundDataPipeline
});
function AddInboundDataPipeline() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.inboundDataPipeline.add'
  });
  useDocumentTitle(t('pageTitle'));
  return <HStack className="w-full p-6 h-[calc(100vh-64px)]">
      <InnerNavigation />
      <Spacer variant="m" />
      <Suspense fallback={<ViewportLoader />}>
        <AddInboundDataPipelineForm />
      </Suspense>
    </HStack>;
}